/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/no-danger */
import React from 'react';

import PropTypes from 'prop-types';
import AniLink from 'gatsby-plugin-transition-link/AniLink';

import ImgHTML from '../ImgHTML';

const ServicesHeading = ({
  headingText: { title, description, img },
  additionalConfig,
  reference,
  click
}) => {
  return (
    <div className="container py-5 pb-3 horizontal-line">
      <div className="row">
        <div className="col-12 col-md-8 d-flex flex-column align-items-start">
          <h2
            className="subtitle bigger"
            dangerouslySetInnerHTML={{
              __html: title
            }}
          />
          <div className="content">
            <p
              className={
                additionalConfig && additionalConfig.type === 'careers'
                  ? 'fixedWidth'
                  : ''
              }
            >
              {description}
            </p>
          </div>
          <div>
            {additionalConfig && additionalConfig.type === 'careers' ? (
              <button
                ref={reference}
                onClick={click}
                type="button"
                bg="#EAEBF1"
                className="btn btn-main narrow fill mt-2 mt-md-4  mx-auto mx-md-0"
              >
                See open positions
              </button>
            ) : (
              <AniLink
                cover
                bg="#EAEBF1"
                to="/contact/"
                className="btn btn-main narrow fill mt-2 mt-md-4  mx-auto mx-md-0"
              >
                Tell us about your idea
              </AniLink>
            )}
          </div>
        </div>
        {additionalConfig ? (
          <div
            className={`col-md-4 m-auto pt-5 py-md-0 ${additionalConfig.type ===
              'careers' && 'd-none d-md-block'}`}
          >
            <div className="d-flex justify-content-around mb-4 col-12 ">
              <ImgHTML src={img[0]} alt="our company" className="col-3 sm-1" />
              <ImgHTML
                src={img[2]}
                alt="our company"
                className="col-4 col-md-9"
              />
            </div>
            <div className="d-flex justify-content-around justify-content-md-between col-12 ">
              <div className="d-none d-md-block" />
              <ImgHTML src={img[1]} alt="our company" className="col-3" />
              <ImgHTML src={img[3]} alt="our company" className="col-3" />
            </div>
          </div>
        ) : (
          <div className="col-6 col-md-4 m-auto pt-5 py-md-0">
            <div className="services-logo text-center my-3">
              <ImgHTML src={img} alt="our company" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ServicesHeading;

ServicesHeading.propTypes = {
  headingText: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    img: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
  }).isRequired,
  additionalConfig: PropTypes.object
};

ServicesHeading.defaultProps = {
  additionalConfig: null
};
